export default __webpack_public_path__ + "static/media/Img0018.3471b693.png";